import { axiosService } from "./axiosService";

const mapApi = {
    // Cabinet API
    getAllCabinet() {
        const url = '/cabinet';
        return axiosService.get(url)
    },
    createCabinet(body) {
        const url = '/cabinet';
        return axiosService.post(url, body)
    },
    updateCabinet(id, body) {
        const url = `/cabinet/${id}`;
        return axiosService.put(url, body)
    },
    deleteCabinet(id) {
        const url = `/cabinet/${id}`;
        return axiosService.delete(url)
    },
    importManyCabinet(body) {
        const url = '/cabinet/import';
        return axiosService.post(url, body)
    },
    // New async cabinet import APIs
    createCabinetImportJob(body) {
        const url = '/cabinet/import';
        return axiosService.post(url, body)
    },
    getCabinetImportJobStatus(jobId) {
        const url = `/cabinet/import/status/${jobId}`;
        return axiosService.get(url)
    },
    getCabinetImportJobs() {
        const url = '/cabinet/import/jobs';
        return axiosService.get(url)
    },

    // Shop API
    getAllShop() {
        const url = '/shop-map';
        return axiosService.get(url)
    },
    createShop(body) {
        const url = '/shop-map';
        return axiosService.post(url, body)
    },
    updateShop(id, body) {
        const url = `/shop-map/${id}`;
        return axiosService.put(url, body)
    },
    deleteShop(id) {
        const url = `/shop-map/${id}`;
        return axiosService.delete(url)
    },
    importManyShop(body) {
        const url = '/shop-map/import';
        return axiosService.post(url, body)
    },
    // New async shop import APIs
    createShopImportJob(body) {
        const url = '/shop-map/import';
        return axiosService.post(url, body)
    },
    getShopImportJobStatus(jobId) {
        const url = `/shop-map/import/status/${jobId}`;
        return axiosService.get(url)
    },
    getShopImportJobs() {
        const url = '/shop-map/import/jobs';
        return axiosService.get(url)
    },

    // General import job APIs
    getImportJobStatus(jobId) {
        const url = `/import/status/${jobId}`;
        return axiosService.get(url)
    },
    getImportJobs(params) {
        const url = '/import/jobs';
        return axiosService.get(url, { params })
    },
}

export default mapApi;